export class SupportPage {

  _questionsElements;

  init() {
    this._questionsElements = document.querySelectorAll('.frequently-asked-questions-section .questions-list__question__top');

    if (this._questionsElements.length > 0) {
      this.questionsElementsActions();
    }
  }

  questionsElementsActions() {
    this._questionsElements.forEach(x => {
      x.addEventListener('click', () => {
        const isActive = x.classList.toggle('active');
        const { nextElementSibling } = x;
        const { offsetHeight } = nextElementSibling.querySelector('.questions-list__question__answer__inner');

        nextElementSibling.style.maxHeight = isActive ? `${ offsetHeight }px` : 0;
      });
    });
  }
}
